const profileFormModel = {
  formId: "profileForm",
  formField: {
    clientFullName: {
      name: "clientDetails.fullName",
      label: "Full Name",
      requiredErrorMsg: "Full Name is required",
    },
    registeredMobileNo: {
      name: "clientDetails.registeredMobileNo",
      label: "Registered Mobile Number",
      // requiredErrorMsg: "Registered Mobile Number is required",
    },
    registeredEmailAddress: {
      name: "clientDetails.registeredEmailAddress",
      label: "Registered Email Address",
      requiredErrorMsg: "Registered Email Address is required",
    },
    clientGender: {
      name: "clientDetails.gender",
      label: "Gender",
      requiredErrorMsg: "Gender is required",
    },
    clientAge: {
      name: "clientDetails.age",
      label: "Age",
      requiredErrorMsg: "Age is required",
    },
    clientCode: {
      name: "clientDetails.clientCode",
      label: "Demat Account Client Code",
      requiredErrorMsg: "Client Code is required",
    },
    city: {
      name: "clientDetails.city",
      label: "City",
      requiredErrorMsg: "City is required",
    },
    nomineeFullName: {
      name: "clientDetails.nomineeFullName",
      label: "Nominee Full Name",
    },
    state: {
      name: "clientDetails.state",
      label: "State",
      requiredErrorMsg: "State is required",
    },
    stockMarketExperience: {
      name: "clientDetails.stockMarketExperience",
      label: "Stock Market Experience",
      requiredErrorMsg: "Stock Market Experience is required",
    },

    insurancePolicies: {
      name: "insuranceCoverage.insurancePolicies",
      label: "Insurance Coverage",
    },
    trading: {
      name: "tradingAndInvestment.trading",
      label: "Trading  ",
      requiredErrorMsg: "Trading is required",
    },
    investment: {
      name: "tradingAndInvestment.investment",
      label: "Investment  ",
      requiredErrorMsg: "Investment is required",
    },
    tradingPreferences: {
      name: "tradingAndInvestment.tradingPreferences",
      label: "Trading Preferences",
    },

    salaryAmount: {
      name: "salaryAmount",
      label: "Salary Amount (₹)",
      requiredErrorMsg: "Salary Amount is required",
    },
    businessAmount: {
      name: "businessAmount",
      label: "Business Amount (₹)",
      requiredErrorMsg: "Business Amount is required",
    },
    agricultureAmount: {
      name: "agricultureAmount",
      label: "Agriculture Amount (₹)",
      requiredErrorMsg: "Agriculture Amount is required",
    },
    interestAmount: {
      name: "interestAmount",
      label: "Interest Amount (₹)",
      requiredErrorMsg: "Interest Amount is required",
    },
    rentalAmounts: {
      name: "rentalAmounts",
      label: "Rental Amounts",
    },
    flatType: {
      name: "flatType",
      label: "Flat Type",
    },
    flatAmount: {
      name: "flatAmount",
      label: "Flat Amount (₹)",
    },
    carEmi: {
      name: "carEmi",
      label: "Car EMI (₹)",
    },
    bikeEmi: {
      name: "bikeEmi",
      label: "Bike EMI (₹)",
    },
    schoolFees: {
      name: "schoolFees",
      label: "School Fees",
    },

    realEstateAssets: {
      name: "realEstateAssets",
      label: "Real Estate Assets",
    },
    goldValue: {
      name: "goldValue",
      label: "Gold Value",
    },
    policyValue: {
      name: "policyValue",
      label: "Policy/PF Value",
    },
    bankFdValue: {
      name: "bankFdValue",
      label: "Bank FD Value",
    },
    cashInBankValue: {
      name: "cashInBankValue",
      label: "Cash in Bank Value",
    },
    businessInvestmentValue: {
      name: "businessInvestmentValue",
      label: "Total Present Business Investment Value",
    },
    vehicleCarValue: {
      name: "vehicleCarValue",
      label: "Vehicle & Car Value",
    },
    libilityList: {
      name: "libilityList",
      label: "Liability List",
    },
  },
};

export default profileFormModel;
